// app/javascript/controllers/devise_user_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "formStep",
    "nextBtn","prevBtn","submitBtn",
    "businessSection","addressSection",
    "roleField",
    "progressItem"
  ]
  static values = { index: Number, needsBusiness: Boolean }

  connect() {
    if (typeof this.indexValue !== 'number' || Number.isNaN(this.indexValue)) this.indexValue = 0
    if (typeof this.needsBusinessValue !== 'boolean') this.needsBusinessValue = false

    // Ensure sections reflect current intent on load (e.g., after errors)
    if (this.hasBusinessSectionTarget) {
      this.businessSectionTarget.style.display = this.needsBusinessValue ? "" : "none"
    }
    if (this.hasAddressSectionTarget) {
      this.addressSectionTarget.style.display = this.needsBusinessValue ? "" : "none"
    }

    this.setBusinessFieldsEnabled(this.needsBusinessValue)
    this.sync()
  }

  // step nav
  next()  { if (this.indexValue < this.lastIndex()) { this.indexValue++; this.sync() } }
  prev()  { if (this.indexValue > 0) { this.indexValue--; this.sync() } }

  // business choice buttons
  yesBusiness() {
    this.needsBusinessValue = true
    this.roleFieldTarget.value = "business"
    this.businessSectionTarget.style.display = ""
    this.addressSectionTarget.style.display  = ""
    this.setBusinessFieldsEnabled(true)
    this.indexValue = 3 // jump to business details step
    this.sync()
  }

  noBusiness() {
    this.needsBusinessValue = false
    this.roleFieldTarget.value = "customer"
    this.setBusinessFieldsEnabled(false)
    this.submitForm()
  }

  submitForm() {
    const form = this.element.querySelector("form")
    if (form) {
      // Avoid HTML5 validation blocking submission on hidden steps
      form.querySelectorAll('[required]').forEach((el) => el.removeAttribute('required'))
      form.requestSubmit()
    }
  }

  lastIndex() { return this.needsBusinessValue ? 3 : 2 }

  sync() {
    const last = this.lastIndex()
    this.formStepTargets.forEach((el, i) => el.hidden = i !== this.indexValue)

    this.prevBtnTarget.hidden   = this.indexValue === 0
    this.nextBtnTarget.hidden   = this.indexValue >= last
    this.submitBtnTarget.hidden = this.indexValue < last

    this.updateProgressNav(last)
  }

  updateProgressNav(last) {
    if (!this.hasProgressItemTarget) return
    let lastVisible = null
    const maxVisible = Math.min(last, this.indexValue + 1)
    this.progressItemTargets.forEach((item) => {
      const s = parseInt(item.dataset.stepIndex || "0", 10)
      const shouldHide = s > maxVisible
      item.hidden = shouldHide
      item.classList.toggle("is-hidden", shouldHide)
      if (shouldHide) return

      lastVisible = item

      const state = s < this.indexValue ? "complete" : (s === this.indexValue ? "current" : "upcoming")

      item.classList.toggle("is-complete", state === "complete")
      item.classList.toggle("is-current", state === "current")
      item.classList.toggle("is-upcoming", state === "upcoming")
    })

    this.progressItemTargets.forEach((item) => {
      item.classList.toggle("is-last-visible", item === lastVisible)
    })
  }

  setBusinessFieldsEnabled(enabled) {
    const section = this.hasBusinessSectionTarget ? this.businessSectionTarget : null
    if (!section) return
    section.querySelectorAll('input, select, textarea').forEach((el) => {
      if (enabled) {
        el.removeAttribute('disabled')
      } else {
        el.setAttribute('disabled', 'disabled')
      }
    })
  }
}
